var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThumbsUpDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.00098 8.38009V15.7501C4.00359 16.0482 4.06492 16.3429 4.18145 16.6173C4.29799 16.8917 4.46745 17.1405 4.68016 17.3494C4.89286 17.5583 5.14466 17.7233 5.42115 17.835C5.69765 17.9466 5.99344 18.0027 6.29163 18.0001H15.1041C15.8504 18.0015 16.5768 17.7604 17.174 17.3131C17.7713 16.8658 18.2068 16.2365 18.4151 15.5201L19.9055 10.1801C20.0151 9.77484 20.0294 9.34973 19.9473 8.93803C19.8652 8.52633 19.6888 8.13923 19.4321 7.80702C19.1754 7.47481 18.8452 7.20653 18.4675 7.02316C18.0897 6.8398 17.6746 6.74633 17.2547 6.75009H12.0032L12.4134 2.00009C12.4372 1.74503 12.4072 1.48781 12.3253 1.24508C12.2434 1.00235 12.1114 0.779509 11.9379 0.590986C11.7644 0.402463 11.5533 0.252455 11.3181 0.150667C11.083 0.0488784 10.8291 -0.00242094 10.5728 8.77651e-05C10.3048 0.000465705 10.04 0.0587432 9.79656 0.170931C9.55313 0.283119 9.33682 0.446567 9.16244 0.650088L5.06128 5.50009C4.3759 6.30313 3.99989 7.32446 4.00098 8.38009Z",
    fill: "#303037"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 8.25006C2.5 7.55971 1.94036 7.00006 1.25 7.00006C0.559644 7.00006 0 7.55971 0 8.25006V16.7501C0 17.4404 0.559644 18.0001 1.25 18.0001C1.94036 18.0001 2.5 17.4404 2.5 16.7501V8.25006Z",
    fill: "#303037"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbsUpDark);
export default __webpack_public_path__ + "static/media/thumbs-up-dark.7e3128555ed1427f919a5be42ec3b50e.svg";
export { ForwardRef as ReactComponent };